import { faChartUser } from '@fortawesome/pro-light-svg-icons'
import { permissionCheck } from '../../../baseComponents/PermissionChecker/function'
import { ItemCustomSelectDropDownRowSection } from '../../../forms/CustomSelect/CustomSelectSections/types'
import { TwinDictionary } from '../../../utils/globals/dictionary'
import { getUserPermissions } from '../../../utils/reducers/getters'

export const parseSuppliersToSections = (suppliers: TwinDictionary, dictTrans: TwinDictionary) => {
    const suppliersSectionItems: ItemCustomSelectDropDownRowSection[] = []
    const indexSuppliers: TwinDictionary = {}
    const userPermissions = getUserPermissions('supplier.main')
    if (permissionCheck(userPermissions, 'create')) {
        suppliersSectionItems.push({ value: '', text: dictTrans.createTrans, isSection: true }, { value: 0, text: dictTrans.createNewTrans, icon: faChartUser, className: 'section_items_background' })
        indexSuppliers[0] = { value: 0, text: dictTrans.createNewTrans, icon: faChartUser, className: 'section_items_background' }
    }
    suppliersSectionItems.push({ value: '', text: dictTrans.suppliersTrans, isSection: true })
    for (const key in suppliers) {
        const supplier = suppliers[key]
        suppliersSectionItems.push({ value: supplier.id, text: supplier.name })
        indexSuppliers[supplier.id] = { value: supplier.id, text: supplier.name }
    }

    return { suppliersSectionItems, indexSuppliers }
}